<script setup lang="ts">
import PinMenu from "@/components/icons/PinMenu.vue";
import FiltroIcon from "@/components/icons/FiltroIcon.vue";
import ListaIcon from "@/components/icons/ListaIcon.vue";
import { mobileOverlayStore } from '@/stores/mobileOverlay';
import { useSidebarStore } from "@/stores/sidebar";

useSidebarStore();
</script>

<template>
    <div id="main-mobile-footerbar" class="mobile-footerbar overflow-hidden" @click="hideOverlay">
        <nav class="fixed-bottom">
            <div class="container text-center">
                <div class="row justify-content-center mt-2 align-middle">
                    <div class="col-3 col-sm-2 align-middle">
                        <button type="button" class="btn btn-link mobile-button-size" @click="navegarMapa">
                            <pin-menu />
                        </button>
                    </div>
                    <div class="col-3 col-sm-2 button-link align-middle">
                        <button type="button" class="btn btn-link mobile-button-size" @click="navegarLista">
                            <lista-icon />
                        </button>
                    </div>
                    <div class="col-3 col-sm-2 button-link align-middle">
                        <button type="button" class="btn btn-link mobile-button-size" @click="navegarFiltros">
                            <filtro-icon />
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>

<script lang="ts">
import { mapStores } from "pinia";
import { defineComponent } from "vue";
import router from "@/router";

export default defineComponent({
    name: "MobileFooterbar",
    computed: {
        ...mapStores(useSidebarStore),
    },
    methods: {
        navegarFiltros() {
            router.push('/mobile/filtro');
        },
        navegarLista() {
            router.push('/mobile/lista');
        },
        navegarMapa() {
            router.push('/');
        },
        hideOverlay() {
            mobileOverlayStore.showOverlay = false
            this.SidebarStore.toggleMobile()
        }
    }
})
</script>